import { format } from "../../i18n/labels";
import { useLabels, useMapCore, useSelection } from "../hooks";
import { Button } from "../primitives/Button";

export type SelectionPillProps = { className?: string };

export function SelectionPill({ className }: SelectionPillProps) {
  const core = useMapCore();
  const labels = useLabels();
  const { ids, objects, api } = useSelection();

  if (ids.length === 0) return null;

  const showList = () => {
    if (objects.length > 1) core.store.getState().setInfo({ kind: "multi", objects });
    else if (objects.length === 1) core.info.openObject(objects[0]);

    core.setPanel("info");
  };

  return (
    <div className={["fxmap-pill", className ?? ""].filter(Boolean).join(" ")} data-fxmap="selection-pill" role="status" aria-live="polite">
      <button type="button" className="fxmap-pill-text fxmap-tabular" onClick={showList} data-fxmap-action="show-selection">
        {format(labels.selectedCount, { count: ids.length })}
      </button>
      <Button kind="icon" size="sm" icon="close" label={labels.clearSelection} className="fxmap-pill-clear" action="clear-selection" onClick={() => api.clear()} />
    </div>
  );
}
